import { memo } from 'react'
import { Text } from 'common-components'
import * as Styled from './styled'
import { IAIVideoModel } from 'types/aiVideo'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'

const VideoModelItem: React.FC<{
  model: IAIVideoModel
  isSelected: boolean
  onSelect: () => void
}> = memo(({ model, isSelected, onSelect }) => {
  const { name } = model

  return (
    <Styled.ModelItemWrapper $isSelected={isSelected} onClick={onSelect}>
      <Styled.ModelTextContent>
        <Styled.ModelNameWrapper>
          <Text
            type="subtitle"
            color={isSelected ? 'secondaryDark' : 'secondarySemiDark'}
          >
            {name}
          </Text>
        </Styled.ModelNameWrapper>
      </Styled.ModelTextContent>
    </Styled.ModelItemWrapper>
  )
})

VideoModelItem.displayName = 'VideoModelItem'

const ModelDropdownContent: React.FC<{
  models: Array<IAIVideoModel>
  selectedModelCode: string | null
  onSelect: (modelCode: string | null) => void
}> = ({ models, selectedModelCode, onSelect }) => {
  return (
    <Styled.DropdownListWrapper>
      <Styled.ModelItemWrapper
        $isSelected={selectedModelCode === null}
        onClick={() => onSelect(null)}
      >
        <Styled.ModelTextContent>
          <Styled.ModelNameWrapper>
            <Text
              type="subtitle"
              color={
                selectedModelCode === null
                  ? 'secondaryDark'
                  : 'secondarySemiDark'
              }
            >
              {translate(T.ALL_LABEL)}
            </Text>
          </Styled.ModelNameWrapper>
        </Styled.ModelTextContent>
      </Styled.ModelItemWrapper>
      {models.map((model: IAIVideoModel) => (
        <VideoModelItem
          key={model.id}
          model={model}
          isSelected={model.model === selectedModelCode}
          onSelect={() => onSelect(model.model)}
        />
      ))}
    </Styled.DropdownListWrapper>
  )
}

export default memo(ModelDropdownContent)
